import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import AccessibilityWidget from "./components/feature/AccessibilityWidget";
import ScrollToTop from "./components/feature/ScrollToTop";
import BackToTop from "./components/feature/BackToTop";
import CookieConsent from "./components/feature/CookieConsent";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
      <AccessibilityWidget />
      <BackToTop />
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
